import React from 'react'
import styled from 'styled-components'
import { color } from '../../utils'
import Pace from './Pace'

const Wrapper = styled.div`
  display: inline-block;
  width: 64px;
  height: 64px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  div {
    position: absolute;
    top: 27px;
    width: 11px;
    height: 11px;
    box-shadow: 0 0 10px 0 ${color.primary};
    border-radius: 50%;
    background: ${color.secondary};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
    }
    @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
    }
    @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }
`

const Loader = () => (
  <Wrapper>
    <div>
    </div>
    <div>
    </div>
    <div>
    </div>
  </Wrapper>
)

const SimpleLoader = props => (
  props.pace ? <Pace><Loader /></Pace> : <Loader />
)

export default SimpleLoader



// WEBPACK FOOTER //
// ./src/components/loaders/SimpleLoader.js